import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { GetCsvExcelTradesRequestModel, GetCsvExcelTradesResponseModel } from "@/features/accounts/csv-excel/services/get-trades-model";

export class GetCsvExcelTradesApi {
  /**
   * CsvExcel明細取得API
   */
  public getCsvExcelTrades = async (
    param: GetCsvExcelTradesRequestModel
  ): Promise<GetCsvExcelTradesResponseModel[]> => {
    const path = `/api/csvexcelaccounts/trades`;
    const res = await ApiClient.instance.get<GetCsvExcelTradesResponseModel[]>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
